import { useEffect, type JSX } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Toss post-payment return page (failure path).
 *
 * Toss redirects here when the user cancels or the payment fails.
 * The page parses the Toss error code and maps it to a /cancel
 * reason slug, then immediately navigates there.
 *
 * See .claude/specs/008-web-toss-sdk-integration/subSPEC-04-toss-return-pages.md.
 */

function mapTossFailCode(code: string | null): string {
  if (code === 'USER_CANCEL') return 'user_cancelled';
  return 'toss_failure';
}

export function TossFailPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    const reason = mapTossFailCode(code);
    navigate(`/cancel?reason=${encodeURIComponent(reason)}`, {
      replace: true,
    });
  }, [searchParams, navigate]);

  return (
    <main className="co-container">
      <div className="co-card">
        <p className="co-muted">Payment was not completed. Redirecting…</p>
      </div>
    </main>
  );
}
